<!-- RTK关联管理 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";

export default {
  name: "personnel-associated-devices",
  components: {},
  mixins: [crudMixins],
  data () {
    return {
      form: {},
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '员工名称',
            prop: 'employeeName',
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '员工名称',
            prop: 'employeeId',
            type: "select",
            hide: true,
            dicUrl: '/api/produce/blade-user/select/userList',
            rules: rulesInput(2),
            props: {
              label: "name",
              value: "id"
            },
            dataType: 'string',
            search: true,
            change: ({ value }) => {
              this.fillEmployeeInfo(value)
            }
          },
          {
            label: '所属部门',
            prop: 'deptId',
            addDisplay: false,
            editDisplay: false,
            // dataType: 'string',
            type: 'tree',
            checkStrictly: true,
            dicUrl: '/api/blade-system/dept/tree',
            props: {
              label: "title",
              value: "value",
            },
            search: true,
          },
          {
            label: '设备名称',
            prop: 'deviceId',
            search: true, // 查询是否显示
            overHidden: true,
            type: 'select',
            remote: true,
            dataType: 'number',
            dicUrl: '/api/produce/weidu-device-info/selectPage?deviceName={{key}}&page=1&size=500',
            props: {
              label: 'deviceName',
              value: 'tagId'
            },
            rules: rulesInput(2),
            dicFormatter: (res) => {
              const data = res && res.data ? res.data : res
              const page = data && data.data ? data.data : data
              return page && Array.isArray(page.records) ? page.records : []
            },
            change: ({ value }) => {
              this.fillDeviceInfo(value)
            }
          },

          {
            label: '巡检人角色',
            prop: 'inspectionRoleNames',
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '巡检人角色',
            prop: 'inspectionRoleIdList',
            type: 'select',
            multiple: true,
            hide: true,
            addDisplay: false,
            editDisplay: false,
            span: 24,
            dicData: [],
            props: {
              label: 'roleName',
              value: 'roleId'
            },
          },
          {
            label: '联系方式',
            prop: 'phone',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入人',
            prop: 'createName',
            overHidden: true,
            width: 150,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入时间',
            prop: 'createTime',
            overHidden: true,
            width: 150,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '修改人',
            prop: 'updateName',
            overHidden: true,
            width: 150,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            overHidden: true,
            width: 150,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig('', { type: 'month' }),
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
      defaultParams: { planType: 1 }
    }
  },
  methods: {
    getColumnDicList (prop) {
      const dic = this.$refs.crud && this.$refs.crud.DIC
      return dic && Array.isArray(dic[prop]) ? dic[prop] : []
    },
    findDicRow (prop, value) {
      const column = this.option.column.find(item => item.prop === prop) || {}
      const valueKey = column.props && column.props.value ? column.props.value : 'id'
      return this.getColumnDicList(prop).find(item => String(item[valueKey]) === String(value))
    },
    fillEmployeeInfo (value) {
      if (!value) {
        this.$set(this.form, 'employeeName', '')
        this.$set(this.form, 'deptId', '')
        this.$set(this.form, 'phone', '')
        return
      }
      const employee = this.findDicRow('employeeId', value)
      if (!employee) return
      this.$set(this.form, 'employeeName', employee.name || employee.realName || '')
      this.$set(this.form, 'deptId', employee.deptId || '')
      this.$set(this.form, 'phone', employee.phone || '')
    },
    fillDeviceInfo (value) {
      if (!value) {
        this.$set(this.form, 'deviceName', '')
        this.$set(this.form, 'deviceStatus', '')
        return
      }
      const device = this.findDicRow('deviceId', value)
      if (!device) return
      this.$set(this.form, 'deviceName', device.deviceName || '')
      this.$set(this.form, 'deviceStatus', device.deviceStatus)
    },
    beforeOpen (done, type) {
      this.openType = type
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data
          done()
        })
      } else {
        done()
      }
    },
    normalizeSubmitRow (row) {
      return {
        ...row,
        employeeId: row.employeeId == null || row.employeeId === '' ? row.employeeId : String(row.employeeId),
        deviceId: row.deviceId == null || row.deviceId === '' ? row.deviceId : String(row.deviceId)
      }
    },
    rowSave (row, done, loading) {
      this.apiConfig.add(this.normalizeSubmitRow(row)).then(() => {
        this.selectionClear()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        done()
      }, () => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      this.apiConfig.update(this.normalizeSubmitRow(row)).then(() => {
        this.selectionClear()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        done()
      }, () => {
        loading()
      })
    },
    replace (row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    },
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
</style>
